export const LOCALSTORAGE_SIDEBAR = 'defaultSidebarClosed';

export const LOCALSTORAGE_MULTIPLE_SIGNINS = 'multipleSignins';
